import React from 'react';
import Typography from '@material-ui/core/Typography';

const SmplAgTech = () => (
    <div>
        <Typography variant='h2' style={{ marginLeft: '10px', color: '#1c313a', fontWeight: '700', display: 'inline-block', fontFamily: 'Source Sans Pro' }}>
            Smpl
                        </Typography>
        <Typography variant='h2' style={{ marginLeft: '2px', color: '#718792', display: 'inline-block', fontFamily: 'Source Sans Pro'}}>
            AgTech
                        </Typography>
    </div>
);

export default SmplAgTech;
